import {Button, Link, Stack, Table, TableCell, Typography, styled} from '@mui/material';

const STATUS_COLORS: Record<string, {color: string; background: string}> = {
  draft: {color: '#7E8285', background: '#F2F4F8'},
  submitted: {color: '#F09B00', background: '#FFF2DA'},
  executed: {color: '#3AC977', background: '#DAF5E6'},
  overdued: {color: '#FF5E5E', background: '#FFDEDE'},
};

export const HistoryRoot = styled(Stack)({
  paddingBottom: '16px',
  minHeight: 474,
});

export const HistoryTable = styled(Table)({
  width: '100%',
  borderStyle: 'solid',
  borderColor: '#B9B9B9',
  borderWidth: '0.3px',
});

export const HistoryHeadCell = styled(TableCell)({
  padding: '17px 16px',
  background: '#ECF1F4',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '140%',
  color: '#0C0C0D',
  whiteSpace: 'nowrap',
});

export const HistoryBodyCell = styled(TableCell)({
  padding: '34px 16px',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '140%',
  color: '#0C0C0D',
  whiteSpace: 'nowrap',
  borderBottom: '0.3px solid #E0E0E0',
});

export const InvoiceLink = styled(Link)({
  textDecoration: 'none',
});

export const LinkText = styled(Typography)({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '14px',
  color: '#0D99FF',
});

export const StatusBadge = styled(Stack)<{statusKey: string}>(({statusKey}) => {
  const status = STATUS_COLORS[statusKey] || {color: '#7E8285', background: '#F2F4F8'};
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
    padding: '4px 14px',
    minWidth: '160px',
    borderRadius: '4px',
    fontSize: '14px',
    color: status.color,
    background: status.background,
  };
});

export const DownloadActions = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
});

export const DownloadButton = styled(Button)({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '140%',
  color: '#0D99FF',
  textTransform: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  minWidth: 'auto',
  padding: 0,
});
